import { FunctionComponent, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { useUserUuid } from '../../hooks/useUserUuid';
import { getUrls } from '../../utils/url';

const getSourceFromUrl = (): string => {
    const urlParams = new URLSearchParams(window.location.search);
    const from = urlParams.get('from');
    if (from) {
        return from;
    }
    return '';
};

const getTargetOrigin = (): string => {
    const source = getSourceFromUrl() || window.localStorage.getItem('calendar_source') || '';
    window.localStorage.setItem('calendar_source', source);
    if (!source) {
        return `https://calendar.${process.env.REACT_APP_DOMAIN_NAME}`;
    }
    if (source === 'localhost:3900') {
        return 'http://localhost:3900';
    }
    if (source.endsWith('calendar.class.com')) {
        return `https://${source}`;
    }
    return `https://calendar.${process.env.REACT_APP_DOMAIN_NAME}`;
};

const MSCalendarIntegration: FunctionComponent = () => {
    const { t } = useTranslation('ms_calendar_integration');
    const userUuid = useUserUuid('react/msCalendarIntegration');
    const { api } = getUrls();
    const targetOrigin = getTargetOrigin();
    useEffect(() => {
        if (userUuid) {
            window.opener.postMessage({ type: 'newConfiguration', value: { userUuid, endpoint: api } }, targetOrigin);
        }
    }, [userUuid, targetOrigin, api, t]);
    return (
        <div>
            <h1>{t('closewindow')}</h1>
        </div>
    );
};
export default MSCalendarIntegration;
